import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout";
import SupportChat from "./components/SupportChat";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Scans from "./pages/Scans";
import ForgotPassword from "./pages/ForgotPassword";
import Reports from "./pages/Reports";
import Dashboard from "./pages/Dashboard";
import Planning from "./pages/Planning";
import Checklists from "./pages/Checklists";
import Machines, { MachineHistory } from "./pages/Machines";
import MachineTypes from "./pages/MachineTypes";
import ReportDetail from "./pages/ReportDetail";
import NewReport from "./pages/NewReport";
import EditReport from "./pages/EditReport";
import PartsBook from "./pages/PartsBook";
import PartsCatalog from "./pages/PartsCatalog";
import Recipients from "./pages/Recipients";
import Team from "./pages/Team";
import Profile from "./pages/Profile";
import Subscribe from "./pages/Subscribe";
import SignAgreement from "./pages/SignAgreement";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import CompanyDetail from "./pages/admin/CompanyDetail";
import SecurityLog from "./pages/admin/SecurityLog";

function Splash() { return <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-zinc-500">Loading…</div>; }

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
function AdminOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "super_admin") return <Navigate to="/reports" replace />;
  return children;
}
const Shell = ({ children }) => <Layout>{children}</Layout>;

export default function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/login" element={<Login adminMode />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<Navigate to="/forgot-password" replace />} />

          <Route path="/reports" element={<Protected><Shell><Reports /></Shell></Protected>} />
          <Route path="/dashboard" element={<Protected><Shell><Dashboard /></Shell></Protected>} />
          <Route path="/planning" element={<Protected><Shell><Planning /></Shell></Protected>} />
          <Route path="/checklists" element={<Protected><Shell><Checklists /></Shell></Protected>} />
          <Route path="/machines" element={<Protected><Shell><Machines /></Shell></Protected>} />
          <Route path="/machines/:serial" element={<Protected><MachineHistory /></Protected>} />
          <Route path="/machine-types" element={<Protected><MachineTypes /></Protected>} />
          <Route path="/reports/:id" element={<Protected><ReportDetail /></Protected>} />
          <Route path="/report/:id" element={<Protected><ReportDetail /></Protected>} />
          <Route path="/reports/:id/edit" element={<Protected><EditReport /></Protected>} />
          <Route path="/new" element={<Protected><Shell><NewReport /></Shell></Protected>} />
          <Route path="/parts" element={<Protected><Shell><PartsBook /></Shell></Protected>} />
          <Route path="/parts-catalog" element={<Protected><PartsCatalog /></Protected>} />
          <Route path="/recipients" element={<Protected><Recipients /></Protected>} />
          <Route path="/team" element={<Protected><Team /></Protected>} />
          <Route path="/scans" element={<Protected><Scans /></Protected>} />
          <Route path="/profile" element={<Protected><Shell><Profile /></Shell></Protected>} />

          <Route path="/subscribe" element={<Protected><Subscribe /></Protected>} />
          <Route path="/sign-agreement" element={<Protected><SignAgreement /></Protected>} />
          <Route path="/billing-success" element={<Protected><BillingSuccess /></Protected>} />
          <Route path="/billing-cancel" element={<Protected><BillingCancel /></Protected>} />

          <Route path="/admin" element={<AdminOnly><AdminLayout /></AdminOnly>}>
            <Route index element={<AdminDashboard />} />
            <Route path="companies/:cid" element={<CompanyDetail />} />
            <Route path="security" element={<SecurityLog />} />
          </Route>

          <Route path="*" element={<Navigate to="/reports" replace />} />
        </Routes>
        <SupportChat />
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}
